module.exports = __webpack_public_path__ + "components/bookings-online-payment-method/static/bancontact-c82e54b98cda5f77aeca0bfeaf8d1737.svg";